export default __webpack_public_path__ + "static/quality_analysis_service_features-801d2dd3b1d8d67553973c6b8d354de5.svg";